import { render, staticRenderFns } from "./DownloadMaterialBlock.vue?vue&type=template&id=3546ab10&"
import script from "./DownloadMaterialBlock.vue?vue&type=script&lang=js&"
export * from "./DownloadMaterialBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports